import {
    SCENE_INFO,
    ENTER_SCENE_CONFIG,
    BIM_SCENE_CONFIG
} from '../util/constant';

import BIMLayer from '../layer/BIMLayer';

import {
    runUVFlowAnim
} from '../util/Animation';
import Easing from '../util/Easing';
import {
    startAnim
} from '../util/util';

const Vector3 = ht.Math.Vector3;
const SYSTEM_CONFIG = htconfig.CustomConfig;

export default class Map {
	constructor(main) {
		const map = this.map = new ht.cesium.Map();
		this.main = main;
        this.scene3DTiles = {};
        this.sceneHT = {};
        this.mapLayer = {};
        this.initStatus = false;
        this.mapSceneMode = 'realScene';
        this.floorStatus = 'close';
        this.floorLayerAnims = [];
        this.startPositions = [];
        this.endPositions = [];
        this.distance4earths = [];
        this.mainElevatorAnims = [];
        this.firstEnter = true;
        this.firstEnterElevator = true;

		// 设置背景图片
		map.backgroundColor = 'rgba(0,0,0,1)';
		// 开启限制操作禁止进入地底下
		map.earthCameraLimit = true;
        // 设置限制角度为 10°
        map.earthCameraLimitAngle = Math.PI / 18;

		// 创建 🌎 球体
		map.createEarth(() => {
            this.init();
        }, {
            // requestRenderMode: false
            shouldAnimate: true
        });

        // 加载 HT 人工建模场景
        this.addHTDayScene();
        this.addHTNightScene();

        // 加载 HT BIM
        this.addBIMScene();
        
        map.setBaseMap('BImage',{key: 'AhAwfTL3tFcA7gegl2AclV7XteHi_n11QeSXmv_vcJUbri05KSqYu7qj9TEK910P'});
        // map.setBaseMap('MapboxMap',{mapId: 'mapbox.satellite', key: 'pk.eyJ1IjoiMzAzNDY5OTIzMiIsImEiOiJja25qbnVoeHowMnhlMm9wMzVuaHc0NmU3In0.LzipoJwo-iL5NO3RSbBnSA'});
        
        // 加载内网地图服务
        // 加载地形
        if(SYSTEM_CONFIG.terrainUrl) {
            map.addTerrain({
                waterMask: false,       
                vertexNormals: false,
                url: SYSTEM_CONFIG.terrainUrl
            });
        }

        // 设置地图透明度
        map.earthEffect =  {
			alpha: 1,
			enableLighting: false,
            // saturation: 0,
            brightness: 0.8
		};
        // 开启云层
        this.startCloundAnim(true);
	}

	/**
	 * 场景初始化
	 */
	init() {
        const map = this.map;

        // 开启自转
        map.setEarthRotation(true, 0.1);
        // 加载实景模型
        this.add3DTilesScene();

        // 延迟进入场景
        setTimeout(() => {
            // 停止自转
            map.setEarthRotation(false);
            this.initEnterScene();
        }, SYSTEM_CONFIG.enterSceneDelayTime);

        // 地图的交互处理
        map.mi(e => {
            const {
                kind,
                data,
            } = e;
            
            const parkOverview = this.main.parkOverview;
            const g2dDm = this.main.g2d.dm();

            if(kind === 'doubleClickData') {
                if(data) {
                    const uuid = data.uuid;
                    // 十字路口的人工建模场景
                    // if(uuid === 'intersectionPoint') {
                    //     parkOverview.showIntersectionScene();
                    // }
                    
                    // const parent = data.a('parent');
                    // if(parent) {
                    //     const pParent = parent.a('parent');
                    //     if(pParent) {
                    //         const pTag = pParent.getTag();
                    //         if(pTag && pTag === 'floorLayer') {
                    //             if(this.floorStatus === 'close') {
                    //                 // 展开楼宇
                    //                 this.openBuildingFloor();
                    //             }
                    //             else {
                    //                 this.setBuildingFloorOpacity(data.a('parent'));
                    //                 this.map.flyToTarget(data, {
                    //                     distance: 200,
                    //                     animation: {
                    //                         duration: 1000
                    //                     }
                    //                 });
                    //             }
                    //         }
                    //     }
                    // }
                }
                else {
                    // if(this.floorStatus === 'open') { 
                    //     this.setBuildingFloorOpacity();
                    //     this.closeBuildingFloor();
                    // }
                }
            }
        });
	}

    /**
     * 设置建筑楼层透明度
     * @param {*} node 
     * @param {*} opacity 
     * @returns 
     */
    setBuildingFloorOpacity(node) {
        const dm = this.map.dm;
        const floorLayer = dm.getDataByTag('floorLayer');
        
        if(node) {
            startAnim({
                duration: 2000,
                easing: t => t,
                action: v => {
                    let opacity = 1 - v;
                    opacity = opacity < 0.05 ? 0.05 : opacity;
                    floorLayer.eachChild(block => {
                        block.eachChild(n => {
                            n.s({
                                'shape3d.transparent': node !== block,
                                'shape3d.opacity': opacity
                            });
                        });
                    });
                }
            });
        }
        else {
            floorLayer.eachChild(block => {
                block.eachChild(n => {
                    n.s({
                        'shape3d.transparent': false,
                        'shape3d.opacity': 1
                    });
                });
            });
        }
    }

    /**
     * 初次进入场景中
     */
    initEnterScene(index = 0) {
        const info = ENTER_SCENE_CONFIG[index];
        setTimeout(() => {
            this.map.flyTo(info, () => {
                if(index < ENTER_SCENE_CONFIG.length - 1) {
                    index = index + 1;
                    this.initEnterScene(index);
                }
                else {
                    this.initStatus = true;
                }
            });
        }, info.delay);
    }

    /**
     * 设置主视图
     */
    setHomeView(callback, duration = 3000) {
        this.map.flyTo({
            heading: 327.6416791984238,
            height: 166.79761521879848,
            pitch: -10.56553987862856,
            position: [118.04545726064303, 24.610496201216876],
            roll: 6.281803201842271,
            animation: {
                duration: duration
            }
        }, callback);
    }

    /**
     * 开启云层
     */
    startCloundAnim(isRotation = false) {
        const map = this.map;
        if(map) {
            const cloudLayer = this.cloudLayer = new ht.cesium.Cloud({
                imageUrl: 'storage/assets/map/cloud2.png',
                color: 'rgba(255,255, 255,0.3)'
            });
            map.add(cloudLayer);
            isRotation && cloudLayer.startRotationAnim(0.00002);
        }
    }

    /**
     * 移除云层
     */
    stopCloundAnim() {
        if(this.cloudLayer) {
            this.cloudLayer.stopRotationAnim();
            this.cloudLayer.remove();
            this.cloudLayer = null;
        }
    }

    /**
     * 加载倾斜摄影场景数据
     */
    add3DTilesScene() {
        const map = this.map;
        if(!map) return;
        SCENE_INFO.forEach(info => {
            if(info.load) {
                const scene = this.scene3DTiles[info.id] = new ht.cesium.Tiles({
                    id: info.id,
                    url: info.url,
                    isLocation: false,
                    cesiumOptions: {
                         skipLevelOfDetail : false,
                         baseScreenSpaceError : 2048,
                         skipScreenSpaceErrorFactor : 16,
                         skipLevels : 1,
                    }
                });
                map.add(scene, (pTileset, tileset) => {
                    let boundingSphere = tileset.boundingSphere;
                    let cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
                    let surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
                    let offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude,  info.adjustHeight);
                    let translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                    tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
                });
            }
        });
    }

    /**
     * 移除倾斜摄影场景数据
     */
    remove3DTilesScene(name) {
        if(name) {
            if(this.scene3DTiles[name]) {
                this.scene3DTiles[name].remove();
                delete this.scene3DTiles[name];
            }
        }
        else {
            Object.values(this.scene3DTiles).forEach(value => {
                value.remove();
            });
            this.scene3DTiles = {};
        }
    }

    /**
     * 设置倾斜摄影的透明度
     * @param {*} opacity 
     */
    set3DTilesSceneOpacity(opacity) {
        if(opacity === 0 || opacity) {
            Object.values(this.scene3DTiles).forEach(value => {
                if(value) {
                    value.setOpacity(opacity);
                }
            });
        }
    }

    /**
     * 增加 BIM 模型场景
     */
    addBIMScene() {
        const map = this.map;
        const htBIMScene = this.htBIMScene = new ht.cesium.Scene({
            id: 'Park-HT-BIM-Scene',
            scene: 'scenes/开发/BIM.json',
            nodeRender: 'GIS_HT',
            // nodeRender: 'GIS',
            lnglat:  [118.04272292270424,24.616241156600065],
            height: 20,
            orientation: [1, 1, 1],
            isLocation: false,
        });
        map.add(htBIMScene, () => {
           this.setBIMSceneVisible(false);
           // BIM 图层
           this.bimLayer = new BIMLayer(this);
        });
    }

    /**
     * 设置 BIM 场景可见和隐藏
     * @param {*} show 
     */
    setBIMSceneVisible(show = true) {
        this.map.dm.each(node => {
            if(node.uuid && node.uuid.indexOf('Park-HT-BIM-Scene') > -1) {
                node.s('3d.visible', show);
            }
        });
    }

    /**
     * 加载 HT 白天风格的人工建模场景
     */
    addHTDayScene() {
        const map = this.map;

        const htDayScene = new ht.cesium.Scene({
            id: 'Park-HT-Day-Scene',
            scene: 'scenes/开发/软三白天.json',
            lnglat:  [118.04272292270424,24.616241156600065],
            height: 20,
            orientation: [1, 1, 1],
            isLocation: false,
            ignoreProcessing: true,
        });
        map.add(htDayScene, () => {
            this.setHTDaySceneVisible(false);
            this.closeDaySceneLight();
        });
    }
    
    /**
     * 设置 HT 白天风格的人工建模场景的可见
     * @param {*} show 
     */
    setHTDaySceneVisible(show = true) {
        this.map.dm.each(node => {
            if(node.uuid && node.uuid.indexOf('Park-HT-Day-Scene') > -1) {
                node.s('3d.visible', show);
            }
        });
    }

    /**
     * 开启白天的场景辅助光
     */
    openDaySceneLight() {
        const dm = this.map.dm;
        const sceneLight = dm.getDataByTag('dayLights');
        sceneLight.eachChild(node => {
            node.s('light.disabled', true);
        });
    }

    /**
     * 关闭白天场景辅助光
     */
    closeDaySceneLight() {
        const dm = this.map.dm;
        const sceneLight = dm.getDataByTag('dayLights');
        sceneLight.eachChild(node => {
            node.s('light.disabled', false);
        });
    }

    /**
     * 增加夜晚场景
     */
    addHTNightScene() {
        const map = this.map;
        const htNightScene = new ht.cesium.Scene({
            id: 'Park-HT-Night-Scene',
            scene: 'scenes/开发/软三夜晚.json',
            lnglat:  [118.04272292270424,24.616241156600065],
            height: 20,
            orientation: [1, 1, 1],
            isLocation: false,
            ignoreProcessing: true,
        });
        map.add(htNightScene, () => {
            this.setHTNightSceneVisible(false);
            this.closeNightSceneLight();
        });
    }
    
    /**
     * 设置 HT 白天风格的人工建模场景的可见
     * @param {*} show 
     */
    setHTNightSceneVisible(show = true) {
        this.map.dm.each(node => {
            if(node.uuid && node.uuid.indexOf('Park-HT-Night-Scene') > -1) {
                node.s('3d.visible', show);
            }
        });
    }

    /**
     * 开启夜景的灯光
     */
    openNightSceneLight() {
        const dm = this.map.dm;
        const sceneLight = dm.getDataByTag('sceneLight');
        const streetLampLight = dm.getDataByTag('streetLampLight');
        const streetLampLightEffect = dm.getDataByTag('streetLampLightEffect');

        sceneLight.eachChild(node => {
            node.s('light.disabled', false);
        });
        streetLampLight.eachChild(node => {
            node.s('light.disabled', false);
        });
        streetLampLightEffect.eachChild(node => {
            node.s('3d.visible', true);
        });
    }

    /**
     * 关闭夜景的灯光
     */
    closeNightSceneLight() {
        const dm = this.map.dm;
        const sceneLight = dm.getDataByTag('sceneLight');
        const streetLampLight = dm.getDataByTag('streetLampLight');
        const streetLampLightEffect = dm.getDataByTag('streetLampLightEffect');

        sceneLight.eachChild(node => {
            node.s('light.disabled', true);
        });
        streetLampLight.eachChild(node => {
            node.s('light.disabled', true);
        });
        streetLampLightEffect.eachChild(node => {
            node.s('3d.visible', false);
        }); 
    }

    /**
     * 切换数字孪生建筑（人工建模场景）
     */
    switchDigitalTwin() {
        const g3d = this.map.graph3dView;
        const dm = this.map.dm;
        const dof = g3d.getPostProcessingModule('Dof');
        dof.aperture = 0;
        dof.image = 'assets/smartPark/全屏.png';
        g3d.enablePostProcessing('Dof', true); 
        let firstShow = true;

        startAnim({
            duration: 2000,
            easing: t => t,
            action: v => {
                dof.aperture = 0.1 * v;
                this.map.setSceneBlur(true, {
                    sigma: 1 + v * 4,
                    stepSize: v * 5
                });
                Object.values(this.scene3DTiles).forEach(value => {
                    if(value) {
                        value.setOpacity(1 - v);
                    }
                });
            },
            finishFunc: () => {
                startAnim({
                    duration: 2000,
                    easing: t => t,
                    action: v => {
                        dof.aperture = 0.1 * (1 - v);
                        if(firstShow && v > 0.5) {
                            dm.each(node => {
                                if(node.uuid && node.uuid.indexOf('Park-HT-Day-Scene') > -1) {
                                    node.s('3d.visible', true);
                                }
                            });
                            firstShow = false;
                        }
                    },
                    finishFunc: () => {
                        if(dof)
                        this.openDaySceneLight();
                    }
                });
            }
        });
    }

    /**
     * 切换为航拍实景
     */
    switchRealScene() {
        const g3d = this.map.graph3dView;
        g3d.enablePostProcessing('Dof', true); 
        const dof = g3d.getPostProcessingModule('Dof')
        dof.aperture = 0;
        dof.image = 'assets/smartPark/全屏.png';
        this.closeDaySceneLight();
        startAnim({
            duration: 2000,
            easing: t => t,
            action: v => {
                dof.aperture = 0.1 * v;
            },
            finishFunc: () => {
                this.map.dm.each(node => {
                    if(node.uuid && node.uuid.indexOf('Park-HT-Day-Scene') > -1) {
                        node.s('3d.visible', false);
                    }
                });
                g3d.enablePostProcessing('Dof', false); 
                startAnim({
                    duration: 2000,
                    easing: t => t,
                    action: v => {
                        this.map.setSceneBlur(true, {
                            sigma: 5 -  v * 4,
                            stepSize: (1 - v) * 5
                        });
                        Object.values(this.scene3DTiles).forEach(value => {
                            if(value) {
                                value.setOpacity(v);
                            }
                        });
                    }
                });
            }
        });
    }

    /**
     * 开启车辆流动
     */
    startCarFlowAnim() {
        this.stopCarFlowAnim();
        const carFlowNode = this.map.dm.getDataByTag('carFlow');
        if(carFlowNode) {
            this.carFlowAnim = runUVFlowAnim(carFlowNode, -0.005, 'all.uv.offset');
        }
    }

    /**
     * 关闭车流
     */
    stopCarFlowAnim() {
        if(this.carFlowAnim) {
            this.carFlowAnim.pause();
            this.carFlowAnim = null;
        }
    }

    /**
     * 楼宇楼层得展开
     * @param {*} callback 
     */
    openBuildingFloor(callback) {
        const map = this.map;
        const dm = map.dm;
        const annexBuilding = dm.getDataByTag('annexBuilding');
        const floorLayer = dm.getDataByTag('floorLayer');

        map.flyTo({
            heading: 67.10942188340067,
            height: 380.5466715789406,
            pitch: -13.921701275214307,
            position: [118.03563661379955, 24.613556062100123],
            roll: 0.002409245640370372,
            animation: {
                duration: 1000
            }
        }, () => {
            annexBuilding.eachChild(node => {
                node.s({
                    'shape3d.transparent': true,
                    'shape3d.opacity': 0.2
                });
            });
            
            floorLayer.eachChild((floorNode,i) => {
                if(this.firstEnter) {
                    this.startPositions[i] = [];
                    floorNode.eachChild(floor => {
                        const position = floor.getPosition3d();
                        this.startPositions[i].push(new Vector3(position));
                        this.distance4earths.push(ht.Default.getDistance(position, [0, 0, 0]));
                    });
                    if(i === floorLayer.size() - 1) {
                        this.firstEnter = false;
                    }
                }
                this.floorLayerAnims[i] = startAnim({
                    frames: 30,
                    duration: 1500,
                    finishFunc: () => {
                        if(i === floorLayer.size() - 1) {
                            this.floorStatus = 'open';
                            callback && callback();
                        }
                        this.endPositions[i] = [];
                        floorNode.eachChild(floor => {
                            this.endPositions[i].push(new Vector3(floor.getPosition3d()));
                        });
                    },
                    action: v => {
                        floorNode.eachChild((floor,j) => {
                            const dXYZ = this.startPositions[i][j].clone().multiplyScalar(((10 + 10 * i) / this.distance4earths[i]) * v);
                            const nodePosition = this.startPositions[i][j].clone().add(dXYZ);
                            floor.setPosition3d(nodePosition.x, nodePosition.y, nodePosition.z);
                        });

                    }
                });
            });
        });
    }

    /**
     * 楼宇楼层得关闭
     * @param {*} callback 
     */
    closeBuildingFloor(callback) {
        const map = this.map;
        const dm = map.dm;
        const annexBuilding = dm.getDataByTag('annexBuilding');
        const floorLayer = dm.getDataByTag('floorLayer');
        
        annexBuilding.eachChild(node => {
            node.s({
                'shape3d.transparent': false,
                'shape3d.opacity': 1
            });
        });
        
        floorLayer.eachChild((floorNode,i) => {
            this.floorLayerAnims[i] = startAnim({
                frames: 30,
                duration: 1500,
                finishFunc: () => {
                    if(i === floorLayer.size() - 1) {
                        this.floorStatus = 'close';
                        callback && callback();
                    }
                },
                action: v => {
                    floorNode.eachChild((floor,j) => {
                        const dXYZ = this.endPositions[i][j].clone().multiplyScalar(((10 + 10 * i) / this.distance4earths[i]) * v);
                        const nodePosition = this.endPositions[i][j].clone().sub(dXYZ);
                        floor.setPosition3d(nodePosition.x, nodePosition.y, nodePosition.z);
                    });
                }
            });
        });
    }

    /**
     * 开启附楼的电梯动画
     * @param {*} dir 
     */
    startAnnexElevatorRunning(dir=true) {
        const map = this.map;
        const dm = map.dm;
        const annexElevator = dm.getDataByTag('annexElevator');
        let startPositions = [];
        let distance4earths = [];
        this.stopAnnexElevatorRunning();

        if(this.firstEnterElevator) {
            annexElevator.eachChild(node => {
                const _startPosition = [];
                const _distance2earth = [];
                node.eachChild(elevator => {
                    const position = elevator.getPosition3d();
                    _startPosition.push(new Vector3(position));
                    _distance2earth.push(ht.Default.getDistance(position, [0, 0, 0]));
                });
                startPositions.push(_startPosition);
                distance4earths.push(_distance2earth);
            });
                
            this.annexElevatorStartPositions = startPositions;
            this.annexElevatorDistance4earths = distance4earths;
            this.firstEnterElevator = false;
        }
        else {
            annexElevator.eachChild((node,i) => {
                node.eachChild((elevator,j) => {
                    const _position = this.annexElevatorStartPositions[i][j];
                    elevator.setPosition3d(_position.x, _position.y, _position.z);
                });
            });
            startPositions = this.annexElevatorStartPositions;
            distance4earths = this.annexElevatorDistance4earths;
        }

        annexElevator.eachChild((node,i) => {
            this.annexElevatorAnims[i] = startAnim({
                delay: 1000,
                duration: 5000,
                easing: Easing.easeOut,
                action: v => {
                    node.eachChild((elevator, j) => {
                        const dXYZ = startPositions[i][j].clone().multiplyScalar((80 / distance4earths[i][j]) * v);
                        const nodePosition = dir ? startPositions[i][j].clone().add(dXYZ) : startPositions[i].clone().sub(dXYZ);
                        elevator.setPosition3d(nodePosition.x, nodePosition.y, nodePosition.z);
                    });
                },
                finishFunc: () => {
                    this.startAnnexElevatorRunning(!dir);
                }
            });
        });
    }

    /**
     * 关闭附楼的电梯动画
     */
    stopAnnexElevatorRunning() {
        if(this.annexElevatorAnims) {
            this.annexElevatorAnims.forEach(anim => {
                anim && anim.pause();
            });
        }
        this.annexElevatorAnims = [];
    }

    /**
     * 开启主楼电梯动画
     * @param {*} num 
     * @param {*} down 
     * @param {*} floorNum 
     * @param {*} oldFloor 
     * @returns 
     */
    startMainElevatorRunning(num, down, floorNum, oldFloor) {
        const map = this.map;
        const dm = map.dm;
        const mainElevator = dm.getDataByTag('mainElevator');
        const runningElevator = mainElevator.getChildAt(num - 1);
        const startPositions = [];
        const distance4earths = [];

        if(!runningElevator) return;

        runningElevator.eachChild(node => {
            const position = node.getPosition3d();
            startPositions.push(new Vector3(position));
            distance4earths.push(ht.Default.getDistance(position, [0, 0, 0]));
        });

        if(!runningElevator.a('running')) {
            runningElevator.a('running', true);
            this.mainElevatorAnims[num] = startAnim({
                duration: Math.abs(floorNum - oldFloor) * 500,
                easing: Easing.easeOut,
                action: v => {
                    runningElevator.eachChild((elevator, i) => {
                        const dXYZ = startPositions[i].clone().multiplyScalar((8 * Math.abs(floorNum - oldFloor) / distance4earths[i]) * v);
                        const nodePosition = down ? startPositions[i].clone().sub(dXYZ) : startPositions[i].clone().add(dXYZ);
                        elevator.setPosition3d(nodePosition.x, nodePosition.y, nodePosition.z);
                    });
                },
                finishFunc: () => {
                    runningElevator.a('running', false);
                }
            });
        }
        
    }

    stopMainElevatorRunning() {

    }

    /**
     * 切换楼宇模式
     * @param {*} mode 
     */
    switchDigitalTwinMode(mode = 'day') {
        const map = this.map;
        const dm = map.dm;
        const dayOverallScene = dm.getDataByTag('dayOverallScene');
        const nightOverallScene = dm.getDataByTag('nightOverallScene');

        console.log(dayOverallScene, nightOverallScene);
        
        if(mode === 'day') {
            this.setHTDaySceneVisible(true);
            setNodeOpacity(dayOverallScene, 0);
        }
        else {
            this.setHTNightSceneVisible(true);
            setNodeOpacity(nightOverallScene, 0);
        }

        startAnim({
            duration: 5000,
            easing: t => t,
            action: v => {
                if(mode === 'day') {
                    setNodeOpacity(dayOverallScene, v, v < 1);
                    setNodeOpacity(nightOverallScene, 1 - v, v < 1);
                }
                else {
                    setNodeOpacity(dayOverallScene, 1 - v, v < 1);
                    setNodeOpacity(nightOverallScene, v, v < 1);
                }
            },
            finishFunc: () => {
                if(mode === 'day') {
                    this.setHTNightSceneVisible(false);
                    this.closeNightSceneLight();
                    this.openDaySceneLight();
                }
                else {
                    this.setHTDaySceneVisible(false);
                    this.openNightSceneLight();
                    this.closeDaySceneLight();
                }
            }
        });

    }
}

function setNodeOpacity(block, opacity, transparent = true) {
    const optionProperties = ['shape3d', 'all', 'left', 'right', 'top', 'bottom', 'front', 'back', 'from', 'to'];
    block.eachChild(node => {
        if(node.getChildren().size()) {
            setNodeOpacity(node, opacity, transparent);
        }
        else {
            optionProperties.forEach(k => {
                node.s('3d.visible', true);
                node.s(k + '.opacity', opacity);
                node.s(k + '.transparent', transparent);
            });
        }
    });
}